import { OperationType } from '../../types/interfaces';

import Api from './api';
import IOperationTypesApi from './interfaces/operationTypesApi';

class OperationTypesApi
  extends Api<OperationType>
  implements IOperationTypesApi
{
  constructor(abortController: AbortController) {
    super('operationType/', abortController);
  }
}

export default OperationTypesApi;
